import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useState } from 'react';
import SettingsForm from '../components/SettingsForm';
import TopicsList from '../components/TopicsList';

export default function Settings() {
    const [tab, setTab] = useState('1');

    return (
        <Box sx={{
            maxWidth: 900,
            mx: 'auto',
            p: { xs: '16px 12px 32px', sm: '24px 16px 48px' },
        }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" fontWeight={600} color="#333">
                    Configurações
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Gerencie as configurações e tópicos da plataforma
                </Typography>
            </Box>

            <TabContext value={tab}>
                <Box sx={{
                    bgcolor: 'white',
                    borderRadius: '16px 16px 0 0',
                    border: '1px solid #e8e8e8',
                    borderBottom: 'none',
                }}>
                    <TabList
                        onChange={(_, v) => setTab(v)}
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: '0.9rem',
                            },
                            '& .Mui-selected': {
                                color: '#006a61',
                                fontWeight: 600,
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#006a61',
                            },
                        }}
                    >
                        <Tab label="Configurações" value="1" />
                        <Tab label="Tópicos" value="2" />
                    </TabList>
                </Box>

                <Box sx={{
                    bgcolor: 'white',
                    borderRadius: '0 0 16px 16px',
                    border: '1px solid #e8e8e8',
                    borderTop: 'none',
                }}>
                    <TabPanel value="1" sx={{ p: { xs: 2, sm: 3 } }}>
                        <SettingsForm />
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: { xs: 2, sm: 3 } }}>
                        <TopicsList />
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    );
}
